/*  This is the price toggle class function component. This component uses state class to toggle between two radio buttons
 * and brings in two child components (monthly-pricing.js & annual-pricing.js) which display the pricing data and styling.
 * This conmponent is a parent of the Monthly and Annual child components.
 * inspired from:
 * https:/stackoverflowcomquestions51430364what-is-the-most-efficient-way-to-toggle-between-two-components-react-js
 *
 */

/* [SK] All the modal content for desktop view is located within this file due to the fact the Netlify
 * requires that all forms be visible to the DOM during the inital build.
 */

import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Monthly from './monthly-pricing-desktop';
import Annual from './annual-pricing-desktop';
import PricingPageStyle from './pricing-page.module.scss';

class PricingPlansDesktop extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      display: 'first',
    };
  }

  changeDisplay = () => {
    let { display } = this.state;
    this.setState({ display: display === 'first' ? 'second' : 'first' });
  };

  renderInner() {
    let { display } = this.state;

    if (display === 'first') {
      return <Annual />;
    } else if (display === 'second') {
      return <Monthly />;
    }
  }

  render() {
    return (
      <div
        className={` ${PricingPageStyle.pricingDesktopSection} ${PricingPageStyle.sectionDiv} `}
      >
        <form>
          <Row className={PricingPageStyle.pricingPlansDesktop}>
            <Col md={6} className={PricingPageStyle.pricingPlansDesktopCol1}>
              <input
                className={PricingPageStyle.radioDesktop}
                type='radio'
                aria-label='Annual Pricing'
                value='Annual'
                name='payment'
                onChange={this.changeDisplay}
                defaultChecked={true}
              />
              <h3 className={PricingPageStyle.pricingTerm}>
                Annual Term <strong>(Save 10%)</strong>
              </h3>
            </Col>
            <Col md={6} className={PricingPageStyle.pricingPlansDesktopCol2}>
              <input
                className={PricingPageStyle.radioDesktop}
                type='radio'
                aria-label='Monthly Pricing'
                value='Monthly'
                name='payment'
                onChange={this.changeDisplay}
              />
              <h3 className={PricingPageStyle.pricingTerm}>Monthly Term</h3>
            </Col>
          </Row>
        </form>
        {this.renderInner()}
      </div>
    );
  }
}

export default PricingPlansDesktop;
